export const DateFormatEnum = {
  YYYY_MM_DD: 'yyyy-MM-dd',
  MM_YYYY: 'MM-YY',
  DD_MM_YYYY: 'dd/MM/yyyy',
  MM_DD_YYYY: 'mm-dd-yyyy',
  'MM/YYYY': 'MM/yyyy',
};
